import BusinessPartnerAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner/business-partner.entity';
import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ICreateSettingUserBusinessPartner } from './create-setting-user.interface';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';
import { CustomValidators, matchingPasswords } from 'app/utils/helper';
import { AuthService } from 'app/core/auth/auth.service';
import { BusinessPartnerTypeService } from '../../business-partner-type/business-partner-type.service';
import BusinessPartnerTypeAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner-type/business-partner-type.entity';
import { MatSelectModule } from '@angular/material/select';
import { OrdersCreationService } from 'app/modules/components/sales/order-generate/order-generate.service';
import { IRequestResult } from 'app/common/interfaces';
import { MasterUserInterface } from 'app/modules/components/sales/order-generate/interfaces/master-user.interface';
import { buildQuery, Ops, where } from '@albatrosdeveloper/ave-utils-npm/lib/utils/query.util';
import { MastersUserAttributes } from '@albatrosdeveloper/ave-models-package';
import { UserMasterService } from 'app/modules/components/routing/sub-routes/sub-route-collaborator/user_master.service';

@Component({
  selector: 'app-setting-user',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    FormsModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatInputModule,
    MatSlideToggleModule,
    MatIconModule,
    MatSelectModule
  ],
  templateUrl: './setting-user.component.html',
  styleUrl: './setting-user.component.scss'
})
export class SettingUserComponent {

  form: FormGroup;
  first_name = new FormControl({value:'', disabled:true}, [Validators.required])
  email = new FormControl('', [Validators.required, Validators.email,])
  username = new FormControl('', [Validators.required])
  password = new FormControl(null)
  password_confirmation = new FormControl(null)
  allow_shared_user = new FormControl(false, [Validators.required])
  type = new FormControl([])

  hide:boolean = false
  hideold:boolean = false
  hidenew:boolean = false

  businessPartnerFilterTypeList: BusinessPartnerTypeAttributes[] = []
  applicationList: any[] = []

  isExist: boolean
  editPassword: boolean = true
  old_password = null
  user = null

  constructor(
    private authService: AuthService,
    private userMasterService: UserMasterService,
    private readonly businessTypeService: BusinessPartnerTypeService,
    private readonly ordersCreationService: OrdersCreationService,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    public formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<SettingUserComponent>,
    @Inject(MAT_DIALOG_DATA) public data: BusinessPartnerAttributes
  ) { 
    this.form = this.formBuilder.group({
      first_name: this.first_name,
      email: this.email,
      username: this.username,
      password: this.password,
      password_confirmation: this.password_confirmation,
      allow_shared_user: this.allow_shared_user,
      type: this.type
    }, {
      validator: matchingPasswords('password', 'password_confirmation') 
    });
  }

  ngAfterViewInit(): void {
    this.dialogRef.updateSize("90%")
    this.getApplications()
    this.getInfoUser()
    this.initForm()
  }

  getInfoUser(){
    const query = buildQuery<MastersUserAttributes>( //MastersUserAttributes no es igual 
      where("business_partner_id", Ops.eq(String(this.data._id)))
    )

    this.ordersCreationService.fetchMasterUsers(query).subscribe({
      next: (res: IRequestResult<MasterUserInterface[]>) => {
        if(res.status == 'success'){
          if(res.data && res.data.length > 0){
            this.isExist = true
            this.editPassword = false
            this.initForm(res.data[0])
            this.user = res.data[0]
          }
        }
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener información de usuarios.","Cerrar",{ duration: 5000});
      },
    })
  }

  initForm(user?){
    if(user){
      this.password.setValidators([
        CustomValidators.patternValidator(/\d/, { hasNumber: true }),
        CustomValidators.patternValidator(/[A-Z]/, { hasCapitalCase: true }),
        Validators.minLength(3),
      ]);
  
      this.password_confirmation.setValidators([]);

      this.first_name.setValue(user.first_name)
      this.email.setValue(user.email)
      this.username.setValue(user?.username)

      const mappedSubApplications = user?.sub_applications_ids?.map((subId: string) => {
        const parentApplication = this.applicationList.find(app =>
          app.subApplications.some(subApp => subApp._id === subId)
        );
    
        return parentApplication ? { parentId: parentApplication._id, subId } : null;
      }).filter(item => item !== null);
      this.type.setValue(mappedSubApplications)
      
    } else if(this.data){
      this.password.setValidators([
        Validators.required,
        CustomValidators.patternValidator(/\d/, { hasNumber: true }),
        CustomValidators.patternValidator(/[A-Z]/, { hasCapitalCase: true }),
        Validators.minLength(3),
      ]);
  
      this.password_confirmation.setValidators([Validators.required]);

      this.first_name.setValue(this.data.name)
      this.data.emails && this.data.emails.length > 0 ? this.email.setValue(this.data.emails[0].email) : null
      this.data.types && this.data.types.length > 0 ? this.type.setValue(this.data.types.map(type => type.code)) : []
    }
    this.cdr.detectChanges();
  }

  compareFn = (option: any, value: any): boolean => {
    return option?.parentId === value?.parentId && option?.subId === value?.subId;
  };


  onPasswordChange(){
    this.password.setValue(null)
    this.password_confirmation.setValue(null)
  }

  onSubmit(){
    if(!this.form.valid){
      return;
    }

    if(!this.isExist){
      if(this.password.value == null || this.password_confirmation.value == null){
        return;
      }

      let parentIds = [... new Set(this.type.value.map((selection: any) => selection.parentId))]

      let info: ICreateSettingUserBusinessPartner = {
        email: this.email.value?.trim()?.toLowerCase(),
        password: this.password.value?.trim(),
        password_confirmation: this.password_confirmation.value?.trim(),
        username: this.username.value?.trim(),
        first_name: this.first_name.value,
        last_name: null,
        allow_shared_user: false, //req send false, this.allow_shared_user.value,
        permissions: {
          business_partner_id: String(this.data._id),
          applications_ids: parentIds,
          sub_applications_ids: this.type.value.map((selection: any) => selection.subId),
        },
        type: "SOCIOS DE NEGOCIO"
      }
  
      this.authService.createUser(info).subscribe({
        next: () => {
          this.snackBar.open("Registro actualizado con éxito", "Cerrar", {duration: 3000,});
          this.dialogRef.close('success')
        },
        error: (err) => {
          this.snackBar.open(err.error.message || "Error al actualizar el registro","Cerrar",{ duration: 3000 });
        },
      });
    }else{
      if(!this.user){
        this.snackBar.open("Usuario no encontrado", "Cerrar", {duration: 3000,});
        return;
      }
      
      /* if(this.editPassword && !this.old_password){
        return;
      } */

      if(this.editPassword && (this.password.value == null || this.password_confirmation.value == null)){
        return;
      }

      let parentIds = [... new Set(this.type.value.map((selection: any) => selection.parentId))]

      let info: any = { //no hay attirbutes
        user_login_id: String(this.user._id),
        business_partner_id: String(this.data._id),      
        email: this.email.value?.trim()?.toLowerCase(),
        oldPass: null, //this.old_password,
        newPass: this.password.value?.trim(),
        confirmPass: this.password_confirmation.value?.trim(),
        applications_ids: parentIds,
        sub_applications_ids: this.type.value.map((selection: any) => selection.subId),  
        allow_shared_user: false,
        type: "SOCIOS DE NEGOCIO"
      }
      
      this.userMasterService.updateUser(info, this.user.masterUserId).subscribe({
        next: () => {
          this.snackBar.open("Registro actualizado con éxito", "Cerrar", {duration: 3000,});
          this.dialogRef.close('success')
        },
        error: (err) => {
          this.snackBar.open(err.error.message || "Error al actualizar el registro","Cerrar",{ duration: 3000 });
        },
      });
    }
  }

  private getFilterBusinessTypes(): void {
    this.businessTypeService.findToComboBox().subscribe({
      next: (res) => {
        this.businessPartnerFilterTypeList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener tipos de socios de negocios.","Cerrar",{ duration: 5000});
      },
    });
  }

  private getApplications(): void{
    this.ordersCreationService.getApplications().subscribe({
      next: (res) => {
        this.applicationList = res;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener aplicaciones.","Cerrar",{ duration: 5000});
      },
    });
  }
}
